module.exports = __webpack_public_path__ + "img/ybmdsh@3x.4ebfdd85.png";